import React from "react";

function Breadcrumb(props) {
    const { items = [], onItemClick } = props;

    return (
        <div className="breadcrumb">
            <span>
                <i className="icon-home"></i>
            </span>

            {items.map((item, index) => {
                const isLast = index === items.length - 1;

                return (
                    <React.Fragment key={index}>
                        <span className="sep">
                            <i className="icon-right-arrow"></i>
                        </span>

                        {isLast ? (
                            <strong>{item}</strong>
                        ) : (
                            <button
                                type="button"
                                className="breadcrumb-button"
                                onClick={() => onItemClick?.(item, index)}
                            >
                                {item}
                            </button>
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
}

export default Breadcrumb;